import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { Link } from 'react-router-dom';
export default function UserProfilePage() {
  const { username } = useParams();
  const { keycloak } = useKeycloak();
  const [profile, setProfile] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isFollowing, setIsFollowing] = useState(false);
  const [checkingFollow, setCheckingFollow] = useState(false);
  const getMediaType = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return 'image';
    if (["mp4", "webm", "ogg"].includes(ext)) return 'video';
    return 'file';
  };

  // 1. Charger profile + vidéos + utilisateur courant
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = keycloak.token;
        const headers = { Authorization: `Bearer ${token}` };

        const [profileRes, videosRes, meRes] = await Promise.all([
          fetch(`https://www.weavevo.com/users/${username}`),
          fetch(`https://www.weavevo.com/users/${username}/videos`),
          fetch('https://www.weavevo.com/myProfil', { headers })
        ]);

        const profileData = await profileRes.json();
        const videosData = await videosRes.json();
        const meData = await meRes.json();

        setProfile(profileData);
        setVideos(videosData);
        setCurrentUserId(meData.id);

        // 2. Vérifier statut d’abonnement si ce n’est pas soi-même
        if (meData.id !== profileData.id) {
          setCheckingFollow(true);
          const statusRes = await fetch(`https://www.weavevo.com/follow/${profileData.id}`, {
            method: 'HEAD',
            headers
          });
          setIsFollowing(statusRes.status === 200);
          setCheckingFollow(false);
        }

      } catch (err) {
        console.error("Erreur chargement profil/utilisateur :", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [username, keycloak.token]);

  // 3. Gérer le clic sur bouton
  const handleFollowToggle = async () => {
    const token = keycloak.token;
    const method = isFollowing ? 'DELETE' : 'POST';
    const res = await fetch(`https://www.weavevo.com/follow/${profile.id}`, {
      method,
      headers: { Authorization: `Bearer ${token}` }
    });
    if (res.ok) {
      setIsFollowing(!isFollowing);
    }
  };

  if (loading) return <div className="container py-5 text-center">Chargement...</div>;
  if (!profile) return <div className="container py-5 text-center text-danger">Utilisateur introuvable</div>;

  return (
    <div className="container py-5">
      <div className="card shadow-sm mb-5">
        {profile.cover_url && (
          <img src={`https://www.weavevo.com${profile.cover_url}`} className="card-img-top" alt="Couverture" style={{ height: 200, objectFit: 'cover' }} />
        )}
        <div className="card-body text-center">
          <img
            src={`https://www.weavevo.com${profile.avatar_url}`}
            alt={profile.display_name}
            className="rounded-circle mb-3"
            style={{ width: 100, height: 100, objectFit: 'cover', border: '3px solid #fff', marginTop: -50 }}
          />
          <h4 className="mb-0">{profile.display_name}</h4>
          <p className="text-muted">{profile.handle}</p>
          <p className="mt-2">{profile.bio}</p>

          {/* ✅ Bouton abonnement : vérification stricte */}
          {currentUserId && profile.id !== currentUserId && !checkingFollow && (
            <button
              onClick={handleFollowToggle}
              className={`btn btn-${isFollowing ? 'secondary' : 'primary'} btn-sm mt-2`}
            >
              {isFollowing ? 'Se désabonner' : 'S’abonner'}
            </button>
          )}

          <div className="d-flex justify-content-center gap-4 mt-3 text-muted">
            <div><strong>{profile.followers}</strong> abonnés</div>
            <div><strong>{profile.following}</strong> abonnements</div>
            <div><strong>{profile.monthly_views}</strong> vues/mois</div>
          </div>
        </div>
      </div>

      <h5 className="mb-3">📽️ Médias partagés</h5>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
        {videos.length === 0 && <p className="text-muted">Aucun média publié pour le moment.</p>}
        {videos.map((media) => (
          <div className="col" key={media.id}>
            <div className="card h-100 shadow-sm">
              {getMediaType(media.file_path || media.location) === 'image' ? (
                <img src={`https://www.weavevo.com/uploads/${media.file_path || media.location}`} className="card-img-top" alt={media.title} />
              ) : (
                <video src={`https://www.weavevo.com/uploads/${media.file_path || media.location}`} className="card-img-top" controls />
              )}
              <div className="card-body">
                <h5 className="card-title">{media.title}</h5>
              </div>
            </div>
            
          </div>
        ))}
      </div>
    </div>
  );
}
